import gql from "graphql-tag";

export const EDIT_RESOURCES_ON_MATERIAL_DATAS = gql`
  mutation editResourceOnMaterialDatas($where: UpdateResourceOnMaterialDatasInput!) {
    editResourceOnMaterialDatas(where: $where)
  }
`;